module.exports = __webpack_public_path__ + "media/images/svgs/jobs/chip-ab2ded6125d220002cd6bc5159e196d0.svg";